export const MUTED_CUEPOINT_INFO_URL =
  "https://steezy.zendesk.com/hc/en-us/articles/360061629151-Why-is-there-no-music-in-some-of-the-classes-I-am-taking";
